// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1MlLg","list":"PatternAutocomplete_list__3B90N"};